<div class="vit-vital-sign-chart-parent">
  <div *ngIf="showTitle" class="d-flex align-items-center vit-vital-sign-chart-parent_title mb-3">
    <span>{{'SI_VITAL_SIGN_CONSULTATION' | translate}}</span>
    <div class="ml-auto ml-sm-2 d-flex">
      <div>
        <si-go-to-route-icon [href]="['/vital-sign/help']"
                             icon="icosun-help_circle font-color-main1"
                             tooltip="SI_VITAL_SIGN_HELP"
        ></si-go-to-route-icon>
      </div>
      <div *siEnvironment="[configVariableValues.GOOGLE_FIT_SYNC]" class="ml-1">
        <si-go-to-route-icon [href]="['/profile/settings/connection']"
                             icon="icosun-gear"
                             tooltip="SI_SETTINGS"
        ></si-go-to-route-icon>
      </div>
    </div>
  </div>
  <div class="d-flex mb-2">
    <div *ngIf="model">
      <div class="vit-vital-sign-chart-parent_constant">
        {{model?.name}}
      </div>
      <div *ngIf="average" class="vit-vital-sign-chart-parent_text mb-2">
        <span>{{'SI_AVERAGE' | translate}}: </span>
        <span>{{average}} {{model?.unit?.name}}</span>
      </div>
    </div>
    <div class="ml-auto">
      <si-selector-custom text="SI_STATE_CHANGE"
                          path="/api/v1/vital/signs/types"
                          [selectDefault]="true"
                          [showHighlight]="true"
                          (modelChange)="onChangeVitalSign($event)">
        <button class="si-button_main si-button_small">
          <div class="d-flex align-items-center">
            <i class="icosun-arrow_swap mr-1"></i>
            <span class="text-capitalize pr-1">{{'SI_CHANGE_INF' | translate}}</span>
          </div>
        </button>
      </si-selector-custom>
    </div>
  </div>
  <div [hidden]="hideChart">
    <div class="mx-auto">
      <si-vit-vital-sign-chart [sizePage]="sizePage"
                               [unit]="model?.unit?.name"
                               [name]="model?.name"
                               [vitalSignType]="model?.code"
                               [useLoader]="useLoader"
                               [chartHeight]="chartHeight"
                               (onAverage)="onChangeAverage($event)"
      ></si-vit-vital-sign-chart>
    </div>
  </div>
  <ng-container *ngIf="showRecordButton && isMobileWidth">
    <div *siSecure="['vital_sign:management']">
      <div class="pasi-bottom-button_space"></div>
      <div class="pasi-bottom-button">
        <si-go-to-route-button text="SI_ADD_VITAL_SIGN"
                               [href]="['/vital-sign/create']"
                               styleClass="si-button_main w-100"
        ></si-go-to-route-button>
      </div>
    </div>
  </ng-container>
</div>
